import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    TextField,
    Button,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const UploadImage = ({ setImageDialog, imageDialog, getSubOrder, selectedsubOrder, setReload,setgetSubOrder }) => {
    const [addImage, setAddImage] = useState();
    //handle close
    const handleClose = () => {
        setImageDialog(false);
    }

    const handleAddImage = async (selectedsubOrder) => {

        try {
            if (!addImage) {
                return toast.error("Please select a Image file before submitting.");
            }

            const formData = new FormData();
            formData.append("finalImage", addImage);
            formData.append("order_id", selectedsubOrder._id); // Append the order ID to the FormData
            const response = await instance.patch("/Order/uploadfinalImage", formData);
            
            if (response.data.success === true) {
                toast.success(response.data.message);
                handleClose();
                setgetSubOrder(true); // Refresh the suborder list
                setReload()
            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };


    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={imageDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Upload Image
                    <Typography>Please upload the image for the selected suborder.</Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <hr style={{ margin: "10px 0px" }} />
                <DialogContent dividers>
                    <section className="add-employee">
                        <Grid container spacing={2} >
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        fullWidth
                                        type="file"
                                        accept="image/*, application/pdf"
                                        name="document"
                                        onChange={(e) => setAddImage(e.target.files[0])}
                                        inputProps={{
                                            "aria-label": "Upload document",
                                        }}
                                    />
                                    {/* <Typography variant="caption" sx={{ color: "gray", mt: 1 }}>
                                        Supported formats: JPEG, PNG, PDF
                                    </Typography> */}
                                </div>
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel-btn" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => handleAddImage(selectedsubOrder)}
                        className="add-btn">
                        Add
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment >
    )
}

export default UploadImage;